/** HTML `#app-boot-splash` — keep until the first real screen is ready (avoids logo double-flash). */

export function removeBootSplash(): void {
  try {
    document.getElementById('app-boot-splash')?.remove();
  } catch {
    /* ignore */
  }
}

/** Paths that dismiss the boot splash themselves once their UI is ready. */
export function shouldKeepBootSplash(): boolean {
  try {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    return (
      path === '/crm-login' ||
      path.startsWith('/crm-login/') ||
      path === '/sales-crm' ||
      path === '/field-team-management' ||
      path === '/field-operations' ||
      path === '/sales-team-tracking' ||
      path === '/field-service-management' ||
      path === '/technician-tracking' ||
      path === '/security-workforce-management' ||
      path === '/supervisor-management' ||
      path === '/cleaning-workforce-management' ||
      path === '/field-workforce-management' ||
      path === '/crm-lead-management'
    );
  } catch {
    return false;
  }
}
